import { render, staticRenderFns } from "./WidgetCarouselProductsList.vue?vue&type=template&id=71ef6728&scoped=true"
import script from "./WidgetCarouselProductsList.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselProductsList.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselProductsList.vue?vue&type=style&index=0&id=71ef6728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef6728",
  null
  
)

export default component.exports